import { useEffect, useState } from 'react';

export default function GalleryModal({ slug = 'klinikken-galleri' }) {
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    // Fetch gallery item from CMS by slug or search
    fetch(`https://api.dev.auxo.dk/public/v2/content/galleri?slug=${slug}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.items && data.items.length > 0) {
          setGallery(data.items[0]);
        } else {
          // Fallback fetch all
          fetch('https://api.dev.auxo.dk/public/v2/content/galleri')
            .then((r) => r.json())
            .then((all) => {
              if (all && all.items && all.items.length > 0) {
                setGallery(all.items[0]);
              }
            });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [slug]);

  // Default fallback images from scrape if fetch returns empty
  const fallbackImages = [
    'https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg',
    'https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/4320192f-3e8c-4ece-bf20-999699adc5ee.jpeg',
    'https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/5aea2071-4f6b-4f4c-b231-1dfc61e8cfe8.jpg'
  ];

  const images = (gallery && gallery.images && gallery.images.length > 0) 
    ? gallery.images 
    : fallbackImages;

  const openModal = (index) => {
    setSelectedIndex(index);
    setSelectedImage(images[index]);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIdx = (selectedIndex + 1) % images.length;
    setSelectedIndex(nextIdx);
    setSelectedImage(images[nextIdx]);
  };

  const prevImage = () => {
    const prevIdx = (selectedIndex - 1 + images.length) % images.length;
    setSelectedIndex(prevIdx);
    setSelectedImage(images[prevIdx]);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {images.map((imgUrl, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => openModal(idx)}
            className="group relative overflow-hidden rounded-none border border-[#EDE6D8] bg-white shadow-xs focus:outline-none focus:ring-2 focus:ring-[#5f7365] transition-all cursor-pointer aspect-4/3"
            aria-label={`Åbn billede ${idx + 1} i stor visning`}
          >
            <img
              src={`https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/${imgUrl.replace('https://assets.auxodev.dk/', '')}`}
              alt={`Klinikken i Gram foto ${idx + 1}`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white text-lg">
              <i className="fa-regular fa-magnifying-glass-plus" aria-hidden="true" />
            </div>
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-xs flex items-center justify-center p-4 sm:p-8 animate-in fade-in duration-200"
          onClick={closeModal}
        >
          <div 
            className="relative max-w-5xl max-h-[90vh] flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-emerald-300 text-2xl p-2 focus:outline-none"
              aria-label="Luk visning"
            >
              <i className="fa-regular fa-xmark" aria-hidden="true" />
            </button>

            <img
              src={selectedImage}
              alt="Stor visning af klinikfoto"
              className="max-w-full max-h-[80vh] object-contain rounded-none shadow-2xl"
            />

            <div className="flex items-center justify-between w-full mt-4 text-white text-sm">
              <button
                type="button"
                onClick={prevImage}
                className="px-4 py-2 bg-white/10 hover:bg-white/20 rounded-none transition-colors flex items-center gap-2"
                aria-label="Forrige billede"
              >
                <i className="fa-regular fa-chevron-left" />
                Forrige
              </button>
              <span className="text-xs text-[#A1B5A9]">
                Billede {selectedIndex + 1} af {images.length}
              </span>
              <button
                type="button"
                onClick={nextImage}
                className="px-4 py-2 bg-white/10 hover:bg-white/20 rounded-none transition-colors flex items-center gap-2"
                aria-label="Næste billede"
              >
                Næste
                <i className="fa-regular fa-chevron-right" />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
